
import './measure-weight.tag'
import './measure-volume.tag'
riot.tag2('measurements', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#measure-weight">Меры веса</a></li>\n    <li><a data-toggle="tab" href="#measure-volume">Меры объема</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="measure-weight">\n      <measure-weight></measure-weight>\n    </div>\n    <div class="tab-pane fade" id="measure-volume">\n      <measure-volume></measure-volume>\n    </div>\n  </div>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./pages/settings/measurements/measurements.tag